'use client'

import { useTheme } from 'next-themes'
import { Toaster as SonnerToaster } from 'sonner'

type ToasterTheme = 'light' | 'dark' | 'system'

/** next-themes' resolved theme is `undefined` until it has read the client; defer to the OS then. */
function toasterTheme(resolvedTheme: string | undefined): ToasterTheme {
  if (resolvedTheme === 'dark' || resolvedTheme === 'light') return resolvedTheme
  return 'system'
}

/**
 * The app's one global toaster, following the app theme. Sonner's own `theme` defaults to
 * `'light'`, so a bare `<Toaster />` painted light toasts over a dark app. Mount once, inside the
 * `ThemeProvider` (`@/components/providers`) — outside it `useTheme()` never resolves.
 */
export function Toaster() {
  const { resolvedTheme } = useTheme()
  return <SonnerToaster theme={toasterTheme(resolvedTheme)} richColors closeButton />
}
